import { initializePostHog } from '@/analytics/posthog'
import { loadGoogleMapsPlacesApi } from './bootstrap/googleMaps'
import { renderEnrollmentApp } from './bootstrap/renderEnrollmentApp'
import { setWidgetAssetBaseFromBundleScript } from './bootstrap/widgetAssetBase'
import {
  readCookiePreferences,
  subscribeToCookiePreferences
} from '@/shared/utils/cookiePreferences'
import './index.css'

setWidgetAssetBaseFromBundleScript()

function initializeOptionalServices(functional: boolean, analytics: boolean) {
  if (functional) loadGoogleMapsPlacesApi()
  if (analytics) initializePostHog()
}

const standaloneShell = Boolean(document.getElementById('root')) && !document.getElementById('app')
const preferences = readCookiePreferences()

if (standaloneShell) {
  initializeOptionalServices(preferences?.functional ?? false, preferences?.analytics ?? false)
} else {
  initializeOptionalServices(true, true)
}

subscribeToCookiePreferences(value => {
  initializeOptionalServices(value.functional, value.analytics)
})

function checkForAppContainer() {
  if (!renderEnrollmentApp()) {
    window.setTimeout(checkForAppContainer, 100)
  }
}

checkForAppContainer()
